class SolisMythologyCollection extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-kmy-panel-host]');
    this.grid = this.querySelector('[data-kmy-story-grid]');
    this.live = this.querySelector('[data-kmy-live]');
    this.mobileButton = this.querySelector('[data-kmy-mobile-browse]');
    this.explorer = this.querySelector('[data-kmy-explorer]');
    this.hero = this.querySelector('[data-kmy-hero]');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.addEventListener('click', (event) => this.handleClick(event));
    this.observeMobileBrowse();
  }

  handleClick(event) {
    const productLink = event.target.closest('.kmy-scene, .kmy-product-grid a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href') || '';
      this.track('mythology_story_product_click', {
        product_handle: href.split('/products/')[1]?.split(/[?#]/)[0] || '',
        story: productLink.closest('[data-kmy-panel-story]')?.dataset.kmyPanelStory || '',
        page_position: productLink.closest('.kmy-panel') ? 'story_panel' : 'native_grid',
      });
      return;
    }

    if (event.target.closest('[data-kmy-shop-all]')) {
      this.track('mythology_shop_all_click');
      return;
    }

    const filter = event.target.closest('[data-kmy-filter]');
    if (filter) {
      event.preventDefault();
      this.filterStories(filter.dataset.kmyFilter, filter);
      return;
    }

    const story = event.target.closest('[data-kmy-story]');
    if (story && this.querySelector(`template[data-kmy-template="${CSS.escape(story.dataset.kmyStory)}"]`)) {
      event.preventDefault();
      this.selectStory(story.dataset.kmyStory, true);
      return;
    }

    const opener = event.target.closest('[data-kmy-open-story]');
    if (opener) {
      event.preventDefault();
      this.selectStory(opener.dataset.kmyOpenStory, true);
      return;
    }

    if (event.target.closest('[data-kmy-browse]')) {
      event.preventDefault();
      this.scrollTo(this.explorer);
      this.track('mythology_browse_stories');
    }
  }

  filterStories(category, button) {
    this.querySelectorAll('[data-kmy-filter]').forEach((candidate) => {
      candidate.setAttribute('aria-pressed', String(candidate === button));
    });

    let visible = 0;
    this.querySelectorAll('[data-kmy-story]').forEach((card) => {
      const matches = category === 'all' || card.dataset.kmyCategory === category;
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    if (this.live) this.live.textContent = `${visible} stories shown`;
    this.track('mythology_story_filter', { category, visible });
  }

  selectStory(slug, shouldScroll) {
    const template = this.querySelector(`template[data-kmy-template="${CSS.escape(slug)}"]`);
    if (!template || !this.panel) return;

    this.panel.replaceChildren(template.content.cloneNode(true));
    this.querySelectorAll('[data-kmy-story]').forEach((card) => {
      const active = card.dataset.kmyStory === slug;
      card.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (shouldScroll) this.revealPanel();
    const title = this.panel.querySelector('h3')?.textContent?.trim() || slug;
    if (this.live) this.live.textContent = `${title} selected`;
    this.track('mythology_story_select', { story: slug });
  }

  scrollTo(element) {
    if (!element) return;
    element.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  revealPanel() {
    if (!this.panel) return;
    const rect = this.panel.getBoundingClientRect();
    const comfortableTop = window.innerWidth < 750 ? 82 : 116;
    const alreadyReadable = rect.top >= comfortableTop && rect.top <= window.innerHeight * 0.42;
    if (!alreadyReadable) this.scrollTo(this.panel);
  }

  observeMobileBrowse() {
    if (!this.mobileButton || !this.hero || !this.explorer || !('IntersectionObserver' in window)) return;
    let heroVisible = true;
    let explorerVisible = false;
    const update = () => this.mobileButton.dataset.visible = String(!heroVisible && !explorerVisible);
    new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; update(); }, { threshold: 0.05 }).observe(this.hero);
    new IntersectionObserver(([entry]) => { explorerVisible = entry.isIntersecting; update(); }, { threshold: 0.05 }).observe(this.explorer);
  }

  track(event, detail = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  }
}

if (!customElements.get('solis-mythology-collection')) {
  customElements.define('solis-mythology-collection', SolisMythologyCollection);
}
